import { useState, useEffect, useRef } from 'react';
import { useWeb3React } from '@web3-react/core';
import { localStorage } from 'dibs-browser-storage';

import { injectedConnector, walletConnectConnector } from './useWeb3Connection.tsx';

function useWeb3EagerConnect(): boolean {
    const { activate, active, error } = useWeb3React();
    const [tried, setTried] = useState(false);
    const mountedRef = useRef(false);

    useEffect(() => {
        const iswalletconnect = localStorage.getItem('walletconnect');
        if (!mountedRef.current) {
            mountedRef.current = true;
            if (iswalletconnect) {
                if (
                    walletConnectConnector &&
                    walletConnectConnector.walletConnectProvider?.wc?.uri
                ) {
                    walletConnectConnector.walletConnectProvider = undefined;
                }
                activate(walletConnectConnector, undefined, true).catch(() => {
                    setTried(true);
                });
            } else {
                injectedConnector.isAuthorized().then(isAuthorized => {
                    if (isAuthorized) {
                        /* throwErrors has to be false so that error would be dispatched within useWeb3React
                         * and we would read it in useWeb3Connection
                         * https://github.com/NoahZinsmeister/web3-react/blob/v6/packages/core/src/manager.ts#L149-L157
                         */
                        activate(injectedConnector, undefined, false).catch(() => {
                            setTried(true);
                        });
                    } else {
                        setTried(true);
                    }
                });
            }
        }
        // run on mount only. Make sure mounted only once
    }, [activate]);

    // if the connection worked, wait until we get confirmation of that to flip the flag
    useEffect(() => {
        if (!tried && (active || error)) {
            setTried(true);
        }
    }, [tried, active, error]);

    return tried;
}

export { useWeb3EagerConnect };
